import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { RouteChildrenProps } from 'react-router'
import { Link } from 'react-router-dom'
import { Paper, Container, makeStyles, Button } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

export interface IErrorPageParams {
    errorCode: string;
}

export interface IErrorPageProps extends RouteChildrenProps<IErrorPageParams> {

}

const ErrorCodes = {
    404: 'Page Not Found',
    401: 'Access Denied',
    403: 'Access Forbidden'
}

const useStyles = makeStyles(theme => ({
    errorCode: {
        color: red[600],
        fontWeight: 'bold',
        fontSize: '4rem',
        textAlign: 'center',
        padding: theme.spacing(5, 5, 0, 5)
    },
    errorText: {
        fontSize: '2rem',
        textAlign: 'center',
        padding: theme.spacing(0, 5, 5, 5),
    },
    home: {
        textAlign: 'center',
        padding: theme.spacing(0, 5, 5, 5),
    }
}));

const ErrorDefault = 'An Error Occurred';

const ErrorPage: React.FunctionComponent<IErrorPageProps> = ({
    match
}) => {
    const classes = useStyles();

    const errorCode = match?.params.errorCode ? match?.params.errorCode : 'ERROR';

    const errorText = ErrorCodes[errorCode] ? ErrorCodes[errorCode] : ErrorDefault;

    return (
        <Container>
            <Paper>
                <div className={classes.errorCode}>
                    {errorCode}
                </div>
                <div className={classes.errorText}>
                    {errorText}
                </div>
                <div className={classes.home}>
                    <Button color="primary" component={Link} to="/">Return to Home page</Button>
                </div>
            </Paper>
        </Container>
    )
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/ErrorPage.tsx